import React, { useState, useRef, useEffect } from 'react';
import { FaUser, FaCalendarAlt, FaMapMarkerAlt, FaArrowRight, FaHotel } from 'react-icons/fa';
import LoadindForButton from './LoadingForButton';
import AdminService from '../services/adminService';
import UserService from '../services/userService';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { loggedUser, loggedWedding } from '../store/userSlice';
import { useTranslation } from 'react-i18next';

// Lista plaćenih lokacija sa gradovima
const PAID_LOCATIONS = [
    // { name: 'Hotel Marriott', city: 'Mostar' },
    // { name: 'Hotel Hilton', city: 'Zadar' },
    // { name: 'Grand Hotel', city: 'Zagreb' },
    // { name: 'Villa Aurora', city: 'Dubrovnik' },
    // { name: 'Villa Sunrise', city: 'Split' },
    // { name: 'Restoran Stara Kuća', city: 'Osijek' },
    // { name: 'Restoran Dukat', city: 'Rijeka' },
    // { name: 'Dvorana Crystal', city: 'Zagreb' },
    // { name: 'Dvorana Royal', city: 'Split' },
    // { name: 'Castello Bianco', city: 'Mostar' },
    // { name: 'Park Hotel', city: 'Zadar' },
    // { name: 'Restoran Plaza', city: 'Pula' }
];

const WeddingForm = ({ email, password }) => {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        brideName: '',
        groomName: '',
        date: '',
        location: '',
        city: ''
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [invalidCredentials, setInvalidCredentials] = useState(false);

    // State za autocomplete
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [filteredLocations, setFilteredLocations] = useState([]);
    const suggestionRef = useRef(null);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const isUserLoggedIn = useSelector((state) => state.userStore.isLoggedIn);

    // Zatvori suggestions kad se klikne van
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (suggestionRef.current && !suggestionRef.current.contains(event.target)) {
                setShowSuggestions(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setErrors({ ...errors, [name]: '' });
        setFormData({ ...formData, [name]: value });

        // Autocomplete logika za location
        if (name === 'location') {
            if (value.length >= 2) {
                const filtered = PAID_LOCATIONS.filter(loc =>
                    loc.name.toLowerCase().includes(value.toLowerCase())
                );
                setFilteredLocations(filtered);
                setShowSuggestions(filtered.length > 0);
            } else {
                setShowSuggestions(false);
                setFilteredLocations([]);
            }
        }
    };

    const handleLocationSelect = (location) => {
        setFormData({ ...formData, location: location.name, city: location.city });
        setShowSuggestions(false);
        setFilteredLocations([]);
        setErrors({ ...errors, location: '', city: '' });
    };

    const validate = () => {
        const today = new Date().toISOString().split('T')[0];
        const nameRegex = /^[a-zA-ZšđčćžŠĐČĆŽ\s'-]+$/;
        const cityRegex = /^[a-zA-ZšđčćžŠĐČĆŽ\s'-]+$/;
        const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

        const newErrors = {};
        if (!formData.brideName.trim()) {
            newErrors.brideName = t('brideNameRequired');
        } else if (!nameRegex.test(formData.brideName.trim())) {
            newErrors.brideName = t('brideNameInvalid');
        } else if (formData.brideName.trim().length > 50) {
            newErrors.brideName = t('maxLengthError', { count: 50 });
        }

        if (!formData.groomName.trim()) {
            newErrors.groomName = t('groomNameRequired');
        } else if (!nameRegex.test(formData.groomName.trim())) {
            newErrors.groomName = t('groomNameInvalid');
        } else if (formData.groomName.trim().length > 50) {
            newErrors.groomName = t('maxLengthError', { count: 50 });
        }

        if (!formData.date) {
            newErrors.date = t('dateRequired');
        } else if (new Date(formData.date) < new Date(today)) {
            newErrors.date = t('dateInFuture');
        } else if (!dateRegex.test(formData.date)) {
            newErrors.date = t('dateInvalid');
        }

        if (!formData.location.trim()) {
            newErrors.location = t('locationRequired');
        } else if (formData.location.trim().length < 3) {
            newErrors.location = t('locationMinLength');
        } else if (formData.location.trim().length > 100) {
            newErrors.location = t('maxLengthError', { count: 100 });
        }

        if (!formData.city.trim()) {
            newErrors.city = t('cityRequired');
        }
        else if (!cityRegex.test(formData.city.trim())) {
            newErrors.city = t('cityInvalid');
        }
        else if (formData.city.trim().length < 3) {
            newErrors.city = t('cityMinLength');
        } else if (formData.city.trim().length > 100) {
            newErrors.city = t('maxLengthError', { count: 100 });
        }

        return newErrors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return;
        }

        if (isUserLoggedIn) {
            AdminService.addWedding(formData)
                .then((res) => {
                    dispatch(loggedWedding(res.data.wedding || null));
                    setLoading(false);
                    window.location.reload();
                    setFormData({
                        brideName: '',
                        groomName: '',
                        date: '',
                        location: '',
                        city: ''
                    });
                })
                .catch((err) => {
                    setInvalidCredentials(true);
                    setLoading(false);
                });
            return;
        }

        UserService.loginUser({ email, password })
            .then((res) => {
                Cookies.remove('gAuthToken');
                Cookies.set('authToken', res.data.token, { path: '/' });
                dispatch(loggedUser(res.data.user));
                AdminService.addWedding(formData)
                    .then((res) => {
                        dispatch(loggedWedding(res.data.wedding || null));
                        setLoading(false);
                        navigate('/organization');
                        setFormData({
                            brideName: '',
                            groomName: '',
                            date: '',
                            location: '',
                        });
                    })
                    .catch((err) => {
                        setInvalidCredentials(true);
                        setLoading(false);
                    });
            })
            .catch((err) => {
                setInvalidCredentials(true);
                setLoading(false);
            });
    };

    return (
        <form onSubmit={handleSubmit} className="p-4 w-full max-w-screen-md">
            <div className="relative">
                <label>{t('brideName')}</label>
                <FaUser className="inputWeddingIcon" />
                <input
                    type="text"
                    name="brideName"
                    maxLength={50}
                    value={formData.brideName}
                    onChange={handleChange}
                    className={`inputWedding ${errors.brideName ? '!border-red-500' : 'border-primary-300'}`}
                />
            </div>
            {errors.brideName && <p className="text-red-500 text-sm">{errors.brideName}</p>}

            <div className="relative mt-4">
                <label>{t('groomName')}</label>
                <FaUser className="inputWeddingIcon" />
                <input
                    type="text"
                    name="groomName"
                    maxLength={50}
                    value={formData.groomName}
                    onChange={handleChange}
                    className={`inputWedding ${errors.groomName ? '!border-red-500' : 'border-primary-300'}`}
                />
            </div>
            {errors.groomName && <p className="text-red-500 text-sm">{errors.groomName}</p>}

            <div className="relative mt-4">
                <label>{t('weddingDate')}</label>
                <FaCalendarAlt className="inputWeddingIcon" />
                <input
                    type="date"
                    name="date"
                    value={formData.date}
                    onChange={handleChange}
                    className={`inputWedding !pr-4 ${errors.date ? '!border-red-500' : 'border-primary-300'}`}
                />
            </div>
            {errors.date && <p className="text-red-500 text-sm">{errors.date}</p>}

            <div className="relative mt-4" ref={suggestionRef}>
                <label>{t('weddingLocation')}</label>
                <FaHotel className="inputWeddingIcon" />
                <input
                    type="text"
                    name="location"
                    maxLength={50}
                    value={formData.location}
                    onChange={handleChange}
                    className={`inputWedding ${errors.location ? '!border-red-500' : 'border-primary-300'}`}
                    autoComplete="off"
                />

                {/* Dropdown sa suggestions */}
                {showSuggestions && (
                    <div className="absolute z-10 w-full bg-white border border-gray-300 rounded-md shadow-lg mt-1 max-h-60 overflow-y-auto">
                        {filteredLocations.map((location, index) => (
                            <div
                                key={index}
                                onClick={() => handleLocationSelect(location)}
                                className="px-4 py-2 hover:bg-primary-100 cursor-pointer transition-colors duration-150"
                            >
                                <div className="flex items-center gap-2">
                                    <FaHotel className="text-primary-500 text-sm" />
                                    <span className="text-gray-800 font-medium">{location.name}</span>
                                </div>
                                <div className="flex items-center gap-2 ml-6 mt-1">
                                    <FaMapMarkerAlt className="text-gray-400 text-xs" />
                                    <span className="text-gray-500 text-sm">{location.city}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            {errors.location && <p className="text-red-500 text-sm">{errors.location}</p>}

            <div className="relative mt-4">
                <label>{t('weddingCity')}</label>
                <FaMapMarkerAlt className="inputWeddingIcon" />
                <input
                    type="text"
                    name="city"
                    maxLength={50}
                    value={formData.city}
                    onChange={handleChange}
                    className={`inputWedding ${errors.city ? '!border-red-500' : 'border-primary-300'}`}
                />
            </div>
            {errors.city && <p className="text-red-500 text-sm">{errors.city}</p>}

            {invalidCredentials && <p className="text-red-500 text-sm">{t('invalidCredentials')}</p>}

            <button type="submit" className="submitButton w-full mt-7" disabled={loading}>
                {loading ? <LoadindForButton /> : (
                    <span className="flex justify-center items-center gap-4">
                        {t('continueButton')} <FaArrowRight />
                    </span>
                )}
            </button>
        </form>
    );
};

export default WeddingForm;
